import { styled } from '@mui/material/styles';
import { IconButton } from 'core/common/ui/ui-kit';
import Icon from 'core/svg-sprites/ui/Icon';

export const PlaceholderStyled = styled('div')`
  width: 24px;
  min-width: 24px;
  height: 24px;
`;

export const ButtonBackStyled = styled(IconButton)`
  width: 24px;
  min-width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.palette.header.backButton.color};
`;

export const IconStyled = styled(Icon)`
  width: 24px;
  height: 24px;
  fill: currentColor;
`;
